import React from 'react';
import { ApolloProvider } from '@trello/graphql';
import { useOfflineState } from './useOfflineState';
import { TrelloOnline } from 'app/src/components/TrelloOnline';
import { RoutePreloader } from 'app/src/components/RoutePreloader';

export const App = () => {
  const wasEverOffline = useOfflineState();

  if (wasEverOffline) {
    window.location.href = `/offline?returnUrl=${encodeURIComponent(
      window.location.pathname,
    )}`;
  }

  return (
    <ApolloProvider>
      <RoutePreloader>
        <TrelloOnline />
      </RoutePreloader>
    </ApolloProvider>
  );
};
